






























































import {
    Component,
    Watch,
    Vue
} from 'vue-property-decorator';

import {
    WebSiteModule
} from '@/store';

import axios from 'axios';
import Article from '@/models/Article';
import HtmlMarkup from '@/models/HtmlMarkup';
import ArticleFile from '@/models/ArticleFile';

@Component({
    components: {},
})
export default class ArticleHtmlEdit extends Vue {
    private uri = 'Articles';
    private uriFile = 'ArticleFiles';
    private id = 0;
    private html = '';
    private htmlVisible = false;
    private article = new Article();
    private file: File | null = null;
    private get loading() {
        return WebSiteModule.state.Loading;
    }
    private set loading(v: boolean) {
        WebSiteModule.mutations.setLoading(v);
    }
    private error(e: any) {
        WebSiteModule.mutations.setError(e);
    }
    private fileSize(file: ArticleFile) {
        if (file.Width > 0 && file.Height > 0) {
            return file.Width + '*' + file.Height;
        }
        return '';
    }
    public mounted(): void {
        this.$nextTick(async () => {
            // Сохраняем навигацию
            await WebSiteModule.actions.navigate(this.$route.fullPath);
            if (!this.$route.query.MenuId) {
                return;
            }

            this.id = Number(this.$route.query.MenuId);
            if (isNaN(this.id)) {
                return;
            }
            // Add fonts to whitelist   
            this.$nextTick(async () => {
                await this.loadArticle();
            });
        });
    }
    private async loadArticle() {
        try {
            this.loading = true;
            const response = await axios.get(this.uri + '/' + this.id);
            this.article = new Article(response.data);
            this.loading = false;
        } catch (error) {
            this.loading = false;
            this.error(error);
        }
    }
    private async addFile() {
        if (this.file) {
            const data = new FormData();
            data.append('ArticleId', String(this.article.Id));
            data.append('File', this.file, this.file.name);
            this.loading = true;
            try {
                const response = await axios.post(this.uriFile, data);
                this.article.ArticleFiles.push(new ArticleFile(response.data));
                this.loading = false;
                this.file = null;
            } catch (error) {
                this.loading = false;
                this.error(error);
            }
        }
    }
    private async deleteFile(index: number) {
        const file = this.article.ArticleFiles[index];
        this.loading = true;
        try {
            await axios.delete(this.uriFile + '/' + file.Id);
            this.loading = false;
        } catch (error) {
            this.loading = false;
            this.error(error);
        }
        this.html = HtmlMarkup.removeFileName(file.FileName, this.html);
        this.article.ArticleFiles.splice(index, 1);
    }
    private insertFile(file: ArticleFile) {
        // Имя файла без пробелов
        const fileName = HtmlMarkup.getFileNameTag(HtmlMarkup.removeSpaces(file.FileName));
        this.article.Text += fileName;
        // обновить просмотр
        this.rebuildPreview();
    }
    private togglePreview() {
        if (!this.htmlVisible) {
            this.rebuildPreview();
        }
        this.htmlVisible = !this.htmlVisible;
    }
    private rebuildPreview() {
        this.html = HtmlMarkup.getMarkupArticle(this.article, axios.defaults.baseURL);
    }
    private async save() {
        const row = new Article();
        row.Id = this.article.Id;
        row.Subject = this.article.Subject;
        row.Text = this.article.Text;
        row.Visible = this.article.Visible;
        this.loading = true;
        try {
            await axios.patch(this.uri, row);
            this.loading = false;
            this.error('Сохранено');
        } catch (error) {
            this.loading = false;
            this.error(error);
        }
    }
    private async deleteArticle() {
        this.loading = true;
        try {
            await axios.delete(this.uri + '/' + this.article.Id);
            this.loading = false;
            this.error('Статья удалена');
            setTimeout(() => {
                this.$router.push('/');
            }, 1000);
        } catch (error) {
            this.loading = false;
            this.error(error);
        }
    }
    private get articleText() {
        return this.article.Text;
    }
    @Watch('articleText')
    private onHtmlchanged() {
        if (this.htmlVisible) {
            this.rebuildPreview();
        }
    }
}
